/* loaded by smart-asset */
export default require("./alert.png")